import React from 'react';
import { Clock, CheckCircle, Truck, ThumbsUp } from 'lucide-react';
const features = [{
  name: 'Consistent Freshness',
  description: 'Our frozen chain management ensures products maintain peak freshness from source to your freezer.',
  icon: CheckCircle
}, {
  name: 'Reliable Supply',
  description: 'We maintain robust inventory levels so you never have to worry about stockouts for your business.',
  icon: Truck
}, {
  name: 'Fair Pricing',
  description: 'Competitive wholesale and retail prices without compromising on the quality of our seafood.',
  icon: ThumbsUp
}, {
  name: 'Open Daily',
  description: 'We are open every day until 8:00 PM, making it convenient for you to shop on your schedule.',
  icon: Clock
}];
export function WhyChooseUs() {
  return <section className="py-24 bg-white" data-id="element-152">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
        <div className="lg:text-center mb-16" data-id="element-154">
          <h2 className="text-base text-teal-600 font-semibold tracking-wide uppercase" data-id="element-155">
            Why Choose Gauchos
          </h2>
          <p className="mt-2 text-3xl leading-8 font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-156">
            The Preferred Choice in Kaduna
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-500 lg:mx-auto" data-id="element-157">
            We don't just sell food; we build partnerships based on trust,
            quality, and reliability.
          </p>
        </div>

        <div className="mt-10" data-id="element-158">
          <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10" data-id="element-159">
            {features.map(feature => <div key={feature.name} className="relative" data-id="element-160">
                <dt data-id="element-161">
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-blue-900 text-white" data-id="element-162">
                    <feature.icon className="h-6 w-6" aria-hidden="true" data-id="element-163" />
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-slate-900" data-id="element-164">
                    {feature.name}
                  </p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-slate-500" data-id="element-165">
                  {feature.description}
                </dd>
              </div>)}
          </dl>
        </div>
      </div>
    </section>;
}